var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTrash(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21 22C21 23.1046 20.1046 24 19 24H5C3.89543 24 3 23.1046 3 22V7H21V22ZM7.75 9.5C7.33579 9.5 7 9.83579 7 10.25V20.75C7 21.1642 7.33579 21.5 7.75 21.5C8.16421 21.5 8.5 21.1642 8.5 20.75V10.25C8.5 9.83579 8.16421 9.5 7.75 9.5ZM12 9.5C11.5858 9.5 11.25 9.83579 11.25 10.25V20.75C11.25 21.1642 11.5858 21.5 12 21.5C12.4142 21.5 12.75 21.1642 12.75 20.75V10.25C12.75 9.83579 12.4142 9.5 12 9.5ZM16.25 9.5C15.8358 9.5 15.5 9.83579 15.5 10.25V20.75C15.5 21.1642 15.8358 21.5 16.25 21.5C16.6642 21.5 17 21.1642 17 20.75V10.25C17 9.83579 16.6642 9.5 16.25 9.5ZM22 3.5C22.5523 3.5 23 3.94772 23 4.5V5C23 5.55228 22.5523 6 22 6H2C1.44772 6 1 5.55228 1 5V4.5C1 3.94772 1.44772 3.5 2 3.5H22ZM15 0C16.1046 0 17 0.89543 17 2V2.5H7V2C7 0.89543 7.89543 0 9 0H15Z",
    fill: "#081E56"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrash);
export default __webpack_public_path__ + "static/media/trash.524e7b2ad01f31c559503cd335ec07c9.svg";
export { ForwardRef as ReactComponent };